<template>
    <div class="loading-wrapper">
        <div class="img">
            <img src="../assets/img/loading.gif" alt="">
        </div>
    </div>
</template>

<script>
export default {
    name: 'Loading'
}
</script>

<style lang="less">
.pc-wrapper {
    .loading-wrapper {
        width: 100%;
        text-align: center;
        margin-top: 6rem;
        .img {
            display: inline-block;
            width: 12rem;
        }
    }
}
.wap-wrapper {
    .loading-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        .img {
            width: 20vw;
            position: relative;
        }
    }
}
</style>
